import { convert, Logger, LoggerManager, Severity } from "@asciidoctor/core";

// Asciidoctor 4 logs everything with console.error in the browser. Keep warnings
// (such as the known "no callout found" ones) at warning level, as before.
LoggerManager.setLogger(
    new Logger({
        pipe: (line: string, severity: number) => {
            const log = severity >= Severity.ERROR ? console.error : console.warn;
            log(line.replace(/\n$/, ""));
        },
    }),
);

/**
 * The subset of Asciidoctor options the manual uses. Asciidoctor itself types
 * its options as a bare `object`, so this keeps the call sites checked.
 */
export interface ManualConversionOptions {
    safe: "unsafe" | "safe" | "server" | "secure";
    /** Document attributes; `null` unsets an attribute Asciidoctor sets by default. */
    attributes: Record<string, string | null>;
}

/** Converts AsciiDoc source to embeddable HTML (no html/head/body shell). */
export async function convertManual(content: string, options: ManualConversionOptions): Promise<string> {
    const result = await convert(content, options);
    // convert() only returns a Document when it writes the output to a file,
    // which never happens without a to_file option.
    if (typeof result !== "string") {
        throw new TypeError("Asciidoctor returned a document instead of HTML");
    }
    return result;
}
